import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isSignInWithEmailLink, signInWithEmailLink } from "firebase/auth";
import { auth } from "./firebase";
import { collection, getDocs } from "firebase/firestore";
import { FirebaseApp, db } from "./firebase";
const AuthProvider = (props) => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState("loading");

  useEffect(() => {
    if (props.user === "user") {
      if (isSignInWithEmailLink(auth, window.location.href)) {
        let email = window.localStorage.getItem("emailForSignIn");
        if (!email) {
          email = window.prompt("Please provide your email for confirmation");

          const colref = collection(db, "Users");
          getDocs(colref).then((response) => {
            response.docs.map((item) => {
              const a = { ...item.data(), id: item.id };

              if (a.Email === email) {
                window.localStorage.setItem("emailForSignIn", a.Email);
                window.localStorage.setItem("nameForSignIn", a.Name);
                window.localStorage.setItem("idForSignIn", a.id);
                setIsLoggedIn(
                  isSignInWithEmailLink(auth, window.location.href)
                );
              }
            });
          });
        } else {
          setIsLoggedIn(true);
        }
      } else {
        setIsLoggedIn(false);
      }
    } else {
      if (window.localStorage.getItem("token")) {
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
    }
  }, []);

  if (isLoggedIn == "loading") {
    return <div>Loading...</div>;
  } else if (isLoggedIn === true) {
    return props.children;
  } else {
    navigate("/");
  }
};

export default AuthProvider;
